import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { FeatureEvent, RoutePage } from '@/interface/enum';
import { completeFeatureEvent, isFeatureEventCompleted, isFeatureEventsLoaded } from '@/libraries/featureEvents';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { useRootStore } from '@/stores/rootStore';

const isTutorialOpenFromBetSlip = ref(false);

async function closePopup() {
    await completeFeatureEvent(FeatureEvent.SingleModeBetSlipTutorialCompleted);
}

function openTutorialFromBetSlip() {
    isTutorialOpenFromBetSlip.value = true;
}

function closeTutorialFromBetSlip() {
    isTutorialOpenFromBetSlip.value = false;
}

export function useSingleModeBetSlipTutorialState() {
    const { isSingleModeBetSlipEnabled, isSingleModeBetSlipTutorialEnabled } = storeToRefs(useFeatureToggleStore());
    const { isAsi, isMixParlayMode, isSportsSite } = storeToRefs(useRootStore());
    const route = useRoute();

    const isTutorialEntryVisible = computed(isTutorialApplicable);

    const isCompleted = computed(() => isFeatureEventCompleted(FeatureEvent.SingleModeBetSlipTutorialCompleted));
    const isShowPopup = computed(() => isTutorialApplicable()
        && isFeatureEventsLoaded.value
        && !isCompleted.value
        && route.name === RoutePage.MainBySport);

    function isTutorialApplicable() {
        return isSingleModeBetSlipEnabled.value
            && isSingleModeBetSlipTutorialEnabled.value
            && isAsi.value
            && !isMixParlayMode.value
            && isSportsSite.value;
    }

    return {
        isTutorialEntryVisible,
        isShowPopup,
        isTutorialOpenFromBetSlip,
        openTutorialFromBetSlip,
        closeTutorialFromBetSlip,
        closePopup,
    };
}
